import { FunctionComponent, useState, useEffect } from 'react';
import classNames from 'classnames';
import Tab from '../Tab/Tab';
import { TabProps } from '../Tab/Tab';
import styles from './TabContainer.module.scss';

interface TabContainerProps {
  headerContent: TabProps[] | any[];
  bodyContent: React.ReactElement[];
}

const TabContainer: FunctionComponent<TabContainerProps> = ({ headerContent, bodyContent }) => {
  const [headerItems, setHeaderItems] = useState<TabProps[] | any[]>([]);

  const changeActive = (currentIndex: number) => {
    if (headerItems.length > 0) {
      const updatedHeaderItems = headerItems.map((item, i) => ({
        ...item,
        active: i === currentIndex,
      }));

      setHeaderItems(updatedHeaderItems);
    }
  };

  useEffect(() => {
    if (headerContent.length > 0) {
      const initialHeaderItems = headerContent.map((item, i) => ({
        ...item,
        active: i === 0,
      }));

      setHeaderItems(initialHeaderItems);
    }
  }, [headerContent]);

  return (
    <div className={classNames(styles['tab-container'])}>
      <div className={classNames(styles['tab-container__header'])}>
        {headerItems?.map((item, i) => (
          <div className={classNames(styles['tab-container__header-item'])} key={i}>
            <Tab text={item.text} icon={item.icon} index={i} onClick={changeActive} active={item.active} />
          </div>
        ))}
      </div>

      <div className={classNames(styles['tab-container__body'])}>
        {bodyContent?.map(
          (item, i) =>
            headerItems[i]?.active === true && (
              <div className={classNames(styles['tab-container__body-item'])} key={i}>
                {item}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default TabContainer;
